
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/video",
      function () {
        return require("private-next-pages/solutions/video.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/video"])
      });
    }
  